import { createSlice } from '@reduxjs/toolkit'

import type { PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  smsAcsBlocked: false
}

export const smsAcsBlockedSlice = createSlice({
  name: 'smsAcsBlocked',
  initialState,
  reducers: {
    setSmsAcsBlocked(state, action: PayloadAction<boolean>) {
      state.smsAcsBlocked = action.payload
    }
  }
})
export const { setSmsAcsBlocked } = smsAcsBlockedSlice.actions
export default smsAcsBlockedSlice
